// extracted by mini-css-extract-plugin
export default {"wrapper":"SettingsDrawer_wrapper__wbCxd","layer":"SettingsDrawer_layer__lV-ML","title":"SettingsDrawer_title__Ln7dn"};